// frontend/src/components/Auth/SignupLink.js
// Drop-in replacement for <Link to="/register">. Points at /register only
// when signups are open (or the visitor is following a household invite);
// otherwise it becomes a plain link to the static waitlist lander.
import React from 'react';
import { Link } from 'react-router-dom';
import useSignupStatus from '../../hooks/useSignupStatus';

const isFamilyInvite = (returnUrl) => {
  if (!returnUrl) return false;
  try {
    return decodeURIComponent(returnUrl).startsWith('/family/invite/');
  } catch {
    return false;
  }
};

const SignupLink = ({ className, children, closedLabel = 'Join the Waitlist', returnUrl = null, ...rest }) => {
  const { open, waitlistUrl } = useSignupStatus();

  if (open || isFamilyInvite(returnUrl)) {
    return (
      <Link to={returnUrl ? `/register?returnUrl=${returnUrl}` : '/register'} className={className} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <a href={waitlistUrl} className={className} {...rest}>
      {closedLabel}
    </a>
  );
};

export default SignupLink;
